<template>
  <div class="pos-sidebar-footer">
    <div class="subtotal">
      <div class="text">{{ $t('restaurantSale.subtotal') }}</div>
      <div class="price" data-id="price-subtotal">
        {{ defaultCrrency }}
        {{ (tableSelected.sub_total - tableSelected.total_pre_charge_amount) | format_number }}
      </div>
    </div>
    <div class="taxes">
      <div class="text">
        VAT {{ vatRate ? '(' + vatRate + '%)' : '' }}
      </div>
      <div class="price">
        {{ defaultCrrency }}
        {{ tableSelected.vat_amount | format_number }}
      </div>
    </div>
    <div class="total">
      <div class="text">{{ $t('restaurantSale.total') }}</div>
      <div class="price" data-id="price-subtotal">
        {{ defaultCrrency }}
        {{ (tableSelected.invoice_amount - tableSelected.total_pre_charge_amount) | format_number }}
      </div>
    </div>
    <div class="btn-row">
      <b-dropdown dropdown no-caret>
        <template v-slot:button-content>
          <i class="fas fa-ellipsis-v"></i>
        </template>
        <b-dropdown-item @click.prevent="$emit('showMemberCardForm')">
          <i class="fas fa-id-card"></i>
          {{ $t('restaurantSale.memberCard') }}
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click.prevent="$emit('showQueueListForm')">
          <i class="fas fa-forward"></i>
          {{ $t('restaurantSale.queueList') }}
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item
          :disabled="tableSelected.invoice_status != 'Unpaid' || tableSelected.main_linked_key != null || tableSelected.ref_customer_member_card_id != null"
          @click.prevent="$emit('showCombineTableForm')">
          <i class="fas fa-object-ungroup"></i>
          {{ $t('restaurantSale.combineTable') }}
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item :disabled="tableSelected.invoice_status != 'Unpaid' || tableSelected.main_linked_key != null"
          @click.prevent="$emit('moveTable')">
          <i class="fas fa-chalkboard-teacher"></i>
          {{ $t('restaurantSale.moveTable') }}
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click.prevent="$emit('cleanTable')" :disabled="!tableSelected.table_id ||
          tableSelected.invoice_status == 'Unpaid' || tableSelected.main_linked_key != null
          ">
          <i class="fas fa-chalkboard-teacher"></i>
          {{ $t('restaurantSale.cleanTable') }}
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item :disabled="tableSelected.invoice_status != 'Unpaid' || tableSelected.main_linked_key != null"
          @click.prevent="$emit('cancelOrder')">
          <i class="fas fa-object-ungroup"></i>
          {{ $t('restaurantSale.cancelOrder') }}
        </b-dropdown-item>
        <b-dropdown-item @click.prevent="$emit('showShiftCloseForm')">
          <i class="fas fa-user-clock fa-fw fa-lg"></i>
          {{ $t('restaurantSale.shiftClose') }}
        </b-dropdown-item>
      </b-dropdown>
      <ts-button
        :disabled="!tableSelected.table_id || tableSelected.invoice_status != 'Unpaid' || tableSelected.guest_level_id != 2 || tableSelected.main_linked_key != null"
        @click.prevent="$emit('showLinkedKeysForm')"><i class="fas fa-key fa-fw fa-lg"></i>
        {{ $t('restaurantSale.linkedKey') }}
      </ts-button>
      <ts-button :disabled="tableSelected.invoice_status != 'Unpaid' && !tableSelected.main_linked_key"
        @click.prevent="$emit('addMoreOrder')"><i class="fas fa-cart-plus fa-fw fa-lg"></i>
        {{ $t('restaurantSale.add') }}</ts-button>
      <ts-button :disabled="tableSelected.invoice_status != 'Unpaid' || tableSelected.main_linked_key != null"
        @click.prevent="$emit('printBill')" :waiting="printing" color="info"><i v-if="!printing"
          class="fas fa-file-invoice fa-fw fa-lg"></i>
        {{ $t('restaurantSale.printBill') }}</ts-button>
      <ts-button :disabled="tableSelected.invoice_status != 'Unpaid'"
        @click.prevent="tableSelected.main_linked_key ? onCheckBillLinked() : $emit('showBillForm')" color="success"><i
          class="fas fa-file-invoice-dollar fa-fw fa-lg"></i>
        {{ $t('restaurantSale.checkBill') }}</ts-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarFooter',
  props: {
    tableSelected: {
      type: Object,
      default: () => ({})
    },
    defaultCrrency: {
      type: String,
      default: ''
    },
    vatRate: {
      type: Number,
      default: 0
    },
    printing: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    format_number(value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return 0
    }
  },
  methods: {
    onCheckBillLinked() {
      const table = this.$store.state.restaurantSale.counterCheckout.tables.find(el => el.table_id == this.tableSelected.main_linked_key.table_id)
      this.$emit('onTableSelected', table)
    }
  }
}
</script>